<template>
  <!-- 超出当前方案的单个文件时长：说明差多少、升级后能到多少，直接给升级入口 -->
  <div class="plan-limit" role="alert">
    <span class="material-icons-outlined plan-limit-icon" aria-hidden="true">lock_clock</span>
    <div class="plan-limit-text">
      <strong>{{ $t(`planLimit.${kind}Title`, { minutes, limit: limitMinutes, plan: $t(`planLimit.plans.${currentPlan}`) }) }}</strong>
      <p>{{ $t(`planLimit.${nextPlan ? `upgradeFrom.${currentPlan}` : 'maxed'}`) }}</p>
    </div>
    <button v-if="nextPlan" type="button" class="plan-limit-action" @click="upgrade">{{ $t('planLimit.upgrade') }}</button>
  </div>
</template>

<script>
import { useModals } from '@/composables/modals'

// 单个文件时长上限（分钟）对应的方案，和后端 PLAN_CONTENT_LIMITS 一致
const PLAN_BY_LIMIT = { 20: 'free', 30: 'pro', 60: 'premium' }

export default {
  name: 'PlanLimitNotice',
  props: {
    // video：YouTube 视频；file：上传的音视频文件
    kind: { type: String, required: true },
    minutes: { type: Number, required: true },
    limitMinutes: { type: Number, required: true }
  },
  computed: {
    currentPlan() {
      return PLAN_BY_LIMIT[this.limitMinutes]
    },
    nextPlan() {
      return this.currentPlan !== 'premium'
    }
  },
  methods: {
    upgrade() {
      useModals().handleUpgrade()
    }
  }
}
</script>

<style scoped>
.plan-limit {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-panel);
}

.plan-limit-icon {
  flex-shrink: 0;
  color: var(--ink-secondary);
  font-size: 24px;
}

.plan-limit-text {
  flex: 1;
  min-width: 0;
}

.plan-limit-text strong {
  display: block;
  color: var(--ink-primary);
  font-size: var(--font-size-sm);
  font-weight: 600;
  line-height: 1.5;
}

.plan-limit-text p {
  margin: var(--space-1) 0 0;
  color: var(--ink-secondary);
  font-size: var(--font-size-sm);
  line-height: 1.5;
}

.plan-limit-action {
  flex-shrink: 0;
  min-height: 40px;
  padding: 0 var(--space-4);
  border: 1px solid var(--ink-primary);
  border-radius: var(--radius-md);
  background: var(--ink-primary);
  color: var(--color-text-inverse);
  font: inherit;
  font-size: var(--font-size-sm);
  font-weight: 600;
  cursor: pointer;
}

.plan-limit-action:hover {
  background: color-mix(in srgb, var(--ink-primary) 88%, white);
}

.plan-limit-action:focus-visible {
  outline: 2px solid var(--signal-active-strong);
  outline-offset: 2px;
}

@media (max-width: 640px) {
  .plan-limit {
    flex-wrap: wrap;
  }

  .plan-limit-action {
    width: 100%;
  }
}
</style>
